import { Fragment, useEffect, useState, useMemo, useCallback, memo } from 'react';
import { useSelector } from 'react-redux';
import usePaymentField from 'FormsUI/components/hooks/payment/usePaymentField';
import usePaymentPanel from 'FormsUI/components/hooks/payment/usePaymentPanel';
import { getPaymentEligibilityRequestState, getIsPaymentsConfigured
//@ts-expect-error untyped dependency
} from 'FormsUI/selectors/Payments';
import { getPaymentOptionsExcludingSelectedOptions, getShouldDisableAddPaymentOption, noPaymentLinksOnForm, getIsNoMoreOptions, getIsAnyRowInvalid } from 'FormsUI/utils/PaymentsUtils';
import PaymentEmptyState from 'FormsUI/components/editor/options/payment/PaymentEmptyState';
import PaymentLinkSelect from 'payment-link-components/components/PaymentLinkSelect';
import PaymentOptionsTableWrapper from './PaymentOptionsTableWrapper';
import { DISABLED_ADD_OPTION_REASONS } from 'FormsUI/constants/Payments';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaymentConfigurationContainer = ({
  RequiredField,
  HiddenField,
  LabelField
}) => {
  const {
    paymentData,
    paymentField,
    updatePaymentField,
    handleSelectPaymentOption,
    addPaymentOption
  } = usePaymentField();
  const {
    handlePaymentDeselect
  } = usePaymentPanel();
  const paymentEligibilityRequestState = useSelector(getPaymentEligibilityRequestState);
  const isPaymentsConfigured = useSelector(getIsPaymentsConfigured);
  useEffect(() => {
    if (paymentEligibilityRequestState.isSuccessful() && !isPaymentsConfigured) {
      handlePaymentDeselect();
    }
  }, [paymentEligibilityRequestState, isPaymentsConfigured, handlePaymentDeselect]);
  const [showAllOptions, setShowAllOptions] = useState(false);
  const handleShowAllOptions = showAll => {
    setShowAllOptions(showAll);
  };
  const disableAddPaymentOption = useMemo(() => getShouldDisableAddPaymentOption(paymentData, paymentField.options), [paymentData, paymentField.options]);
  const disableReason = useMemo(() => {
    if (getIsAnyRowInvalid(paymentField.options)) {
      return DISABLED_ADD_OPTION_REASONS.INVALID_ROW;
    }
    if (getIsNoMoreOptions(paymentData, paymentField.options)) {
      return DISABLED_ADD_OPTION_REASONS.NO_MORE_OPTIONS_REMAINING;
    }
    return null;
  }, [paymentData, paymentField.options]);
  const errorSelect = useMemo(() => noPaymentLinksOnForm(paymentField.options), [paymentField.options]);
  const renderTablePaymentSelectColumn = useCallback(valueSelected => {
    const selectOptions = getPaymentOptionsExcludingSelectedOptions(paymentData, paymentField, valueSelected);
    const formattedPaymentValue = valueSelected ? Number(valueSelected) : undefined;
    return /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(PaymentLinkSelect, {
        paymentLinks: selectOptions,
        onChange: handleSelectPaymentOption(valueSelected),
        value: formattedPaymentValue,
        error: errorSelect
      })
    });
  }, [paymentData, handleSelectPaymentOption, paymentField, errorSelect]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [RequiredField, HiddenField, LabelField, paymentData.length ? /*#__PURE__*/_jsx(PaymentOptionsTableWrapper, {
      paymentField: paymentField,
      disableAddPaymentOption: disableAddPaymentOption,
      disableReason: disableReason,
      addPaymentOption: addPaymentOption,
      updatePaymentField: updatePaymentField,
      showAllOptions: showAllOptions,
      setShowAllOptions: handleShowAllOptions,
      renderPaymentSelectColumn: renderTablePaymentSelectColumn
    }) : /*#__PURE__*/_jsx(PaymentEmptyState, {})]
  });
};
export default /*#__PURE__*/memo(PaymentConfigurationContainer);